import collapse from './effects/collapse';
import fade from './effects/fade';
import scale from './effects/scale';
import slide from './effects/slide';

export const transition = { collapse, fade, scale, slide };


// WEBPACK FOOTER //
// ./lib/helpers/transition/index.js